import { gql } from 'urql';

// This module deliberately targets the legacy ARTICULOS/MOVIMIENTOS contract.
// It must not be mixed with the product/sucursal stock API used by /stock/movimientos.
export const STOCK_ARTICULOS = gql`
  query StockArticulos($filter: StockArticuloFilter) {
    stockArticulos(filter: $filter) {
      id codigo nombre descripcion cliente rubro unidad
      peso volumen stock posicion fem esPallet bultosPorPallet
    }
  }
`;

export const STOCK_ARTICULO = gql`
  query StockArticulo($id: ID!) {
    stockArticulo(id: $id) {
      id codigo nombre descripcion cliente rubro unidad
      peso volumen stock posicion fem esPallet bultosPorPallet
    }
  }
`;

export const STOCK_MOVIMIENTOS_POR_ARTICULO = gql`
  query StockMovimientosPorArticulo($articuloId: ID!) {
    stockMovimientosPorArticulo(articuloId: $articuloId) {
      items { id tipo fecha hora cantidadTotal remito usuario tipoComprobante tipoIngreso }
      total page pageSize
    }
  }
`;

export const STOCK_MOVIMIENTOS = gql`
  query StockMovimientos($filter: StockMovimientoFilter) {
    stockMovimientos(filter: $filter) {
      items { id tipo fecha hora cliente usuario remito tipoComprobante tipoIngreso cantidadTotal }
      total page pageSize
    }
  }
`;

export const STOCK_MOVIMIENTO = gql`
  query StockMovimiento($id: ID!) {
    stockMovimiento(id: $id) {
      id tipo fecha hora cliente usuario remito tipoComprobante tipoIngreso cantidadTotal
      detalles { articulo { id codigo nombre } cantidad lote vencimiento ubicacionId ubicacionDestinoId fechaIngreso }
    }
  }
`;

export const STOCK_UBICACIONES = gql`
  query StockUbicaciones { stockUbicaciones { id nombre coordenada zona rack nivel estado } }
`;

export const STOCK_CREAR_ENTRADA = gql`
  mutation StockCrearEntrada($input: StockMovimientoInput!) {
    stockCrearEntrada(input: $input) { id tipo remito }
  }
`;
export const STOCK_CREAR_SALIDA = gql`
  mutation StockCrearSalida($input: StockMovimientoInput!) {
    stockCrearSalida(input: $input) { id tipo remito }
  }
`;
export const STOCK_CREAR_TRASLADO = gql`
  mutation StockCrearTraslado($input: StockMovimientoInput!) {
    stockCrearTraslado(input: $input) { id tipo remito }
  }
`;
export const STOCK_ANULAR_MOVIMIENTO = gql`
  mutation StockAnularMovimiento($id: ID!) { stockAnularMovimiento(id: $id) { id tipo remito } }
`;
